export const getImageUrl = (link?: string) => {
  if (!link) {
    return '';
  }
  return `https://cdn.footystats.org/img/${link}`;
};

export const getClassForItem = (val: number): string => {
  const __class = val < 50 ? 'as-item-red' : 'as-item-green';

  const ranges = [
    { min: -2, max: 10, style: 1 },
    { min: 11, max: 20, style: 2 },
    { min: 21, max: 30, style: 3 },
    { min: 31, max: 40, style: 4 },
    { min: 41, max: 50, style: 5 },

    { min: 51, max: 60, style: 1 },
    { min: 61, max: 70, style: 2 },
    { min: 71, max: 80, style: 3 },
    { min: 81, max: 90, style: 4 },
    { min: 91, max: Infinity, style: 5 },
  ];

  const __style = ranges.find(range => val > range.min && val <= range.max)?.style || 1;

  return `${__class} ${__class}__${__style}`;
};

export const getPercentByPoint = (home: number, away: number) => {
  if(home === away) {
    return 0;
  }

  if(home === 0 || away === 0) {
    return 100;
  }

  let parcent = home > away ? home / away : away / home;
  parcent = (parcent*100) - 100;

  return parcent < 0 ? 0 : parcent.toFixed();
}
